import {createSelector} from 'reselect'
import {selKostAllIds, selKostById, selKostVisibleIds} from 'module/Kost/selector/KostSelector'
import {KostAttr} from 'module/selpan/impl/kost/model/KostUtil'
import {log} from 'common/log'
import {KostSelectOption} from 'module/Kost/type/KostSelectType'

export const selKostSelectDataAll = createSelector(
	selKostAllIds,
	selKostById,
	(allIds, byId) => {
		const start = +(new Date())
		let options: KostSelectOption[] = []
		let optionsById: Record<string, KostSelectOption> = {};
		for (let i = 0; i < allIds.length; i++) {
			let id = allIds[i]
			const model = byId[id]
			if (model) {
				const o = {value: id, label: KostAttr.getStringRepresentation(model), model}
				optionsById[id] = o
				options.push(o)
			}
		}
		const end = +(new Date())
		log.trace('Performance KostSelect selSelectDataAll', start, end, end - start)
		return {options, optionsById}
	},
)

export const selKostSelectDataOnlyVisible = createSelector(
	selKostSelectDataAll,
	selKostVisibleIds,
	(dataAll, visibleIds) => {
		const start = +(new Date())
		let options: KostSelectOption[] = [] // the available options
		let optionsById: Record<string, KostSelectOption> = {}; // all options, mapped for select
		const showAll = !visibleIds.length
		if (showAll) return dataAll
		for (let id of visibleIds) {
			const o = dataAll.optionsById[id]
			if (o) {
				optionsById[id] = o
				if ((showAll || visibleIds.includes(id))) {
					options.push(o)
				}
			}
		}
		const end = +(new Date())
		log.trace('Performance KostSelect selSelectDataOnlyVisible', start, end, end - start)
		return {...dataAll, options, optionsById}
	},
)